import { render, staticRenderFns } from "./SeparatorImagesTwo.vue?vue&type=template&id=0a1970f2&"
import script from "./SeparatorImagesTwo.vue?vue&type=script&lang=js&"
export * from "./SeparatorImagesTwo.vue?vue&type=script&lang=js&"
import style0 from "./SeparatorImagesTwo.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports